<template>
  <LinkButton class="link">Sign Up Now</LinkButton>
</template>

<script>
  import LinkButton from './LinkButton';

  export default {
    components: { LinkButton },
  };
</script>

<style
  scoped
  lang="scss"
>
  .link {
    color: color(white);
    background-color: color(red);
    transition-property: background-color;
    transition-timing-function: timing-function(accelerate);
    transition-duration: duration(fast);

    &:hover,
    &:focus {
      transition-timing-function: timing-function(decelerate);
      background-color: darken(color(red), 10%);
    }
  }
</style>
